import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MappingRule } from './mapping-rule.model';

export interface RulesState extends EntityState<MappingRule> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'rules', idKey: 'id' })
export class MappingRulesStore extends EntityStore<RulesState> {
    constructor() {
        super();
    }

    akitaPreAddEntity(mappingRule: MappingRule) {
        return {
            ...mappingRule,
            status: mappingRule.status.toUpperCase() as MappingRule['status'],
            matchTransactionProperties: {
                ...mappingRule.matchTransactionProperties,
                swipAccountId:
                    +mappingRule.matchTransactionProperties.swipAccountId || null // convert to number to match account id type
            }
        };
    }
}
